import React, { useMemo, useState, useEffect } from 'react'
import {
  Card,
  Row,
  Col,
  Table,
  Select,
  DatePicker,
  Button,
  Statistic,
  Empty,
  Spin,
  message,
  Tooltip,
  Input,
  Divider,
} from 'antd'
import {
  FileDoneOutlined,
  DollarOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  ReloadOutlined,
  SearchOutlined,
  FilePdfOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons'
import dayjs from 'dayjs'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { getPdfConfigAPI } from '../../../../../api/pdfApi'

import BillService from '../../../../services/Billservice'
import './BillReport.css'
import { notify } from '../../../../components/Customs/NotifyProvider'
import {
  canViewModule,
  canCreateModule,
  canUpdateModule,
  canDeleteModule,
} from '../../../../utils/permissionUtils'
const { RangePicker } = DatePicker
const getDrinkLineTotal = (detailsRaw) => {
  try {
    const details =
      typeof detailsRaw === 'string'
        ? JSON.parse(detailsRaw || '{}')
        : (detailsRaw || {})
    const bottleQty = Number(details.bottle_qty || 0)
    const bottleRate = Number(details.price_bottle || 0)
    const bottleTotal = bottleQty * bottleRate
    const pegTotal = (details.pegs || []).reduce((sum, peg) => {
      const q = Number((details.peg_qtys || {})[String(peg.id)] || 0)
      const rate = Number(peg.price || 0)
      return sum + (q * rate)
    }, 0)
    return bottleTotal + pegTotal
  } catch {
    return 0
  }
}

//parcel
const getParcelCharge = (items, settings) => {
  if (!Array.isArray(items)) return 0

  const price = Number(settings?.parcel_charge || 0)

  return items.reduce((sum, item) => {
    if (!item) return sum   //  FIX: skip null/undefined

    const isParcel = Number(item?.is_parcel || 0) === 1
    if (!isParcel) return sum

    const qty = Number(item?.qty || 0)
    return sum + qty * price
  }, 0)
}

const openPdfPrintDialog = (doc, fileName) => {
  const blobUrl = doc.output('bloburl')

  const iframe = document.createElement("iframe")
  iframe.style.position = "absolute"
  iframe.style.top = "-10000px"
  iframe.src = blobUrl

  document.body.appendChild(iframe)

  iframe.onload = () => {
    iframe.contentWindow.focus()
    iframe.contentWindow.print()
  }

  
}



const SalesReport = () => {
  const MODULE_KEY = 'sales_report'
  const canView = canViewModule(MODULE_KEY)
  const canCreate = canCreateModule(MODULE_KEY)
  const canUpdate = canUpdateModule(MODULE_KEY)
  const canDelete = canDeleteModule(MODULE_KEY)
  const isViewOnly = canView && !canCreate && !canUpdate && !canDelete
  const [loading, setLoading] = useState(false)
  const [rowsRaw, setRowsRaw] = useState([])
  const [dateFilter, setDateFilter] = useState('today')
  const [range, setRange] = useState(null)
  const [statusFilter, setStatusFilter] = useState('All')
  const [searchText, setSearchText] = useState('')
  const [settings, setSettings] = useState({})




  const buildFilters = () => {
    if (isViewOnly) return { date: 'today' }
    const filters = {}

    if (dateFilter === 'custom' && range && range.length === 2) {
      filters.from = range[0].format('YYYY-MM-DD HH:mm:ss')
      filters.to = range[1].format('YYYY-MM-DD HH:mm:ss')
    }
    else if (dateFilter === 'today') {
      filters.date = 'today'
    }
    else if (dateFilter === 'yesterday') {
      filters.date = 'yesterday'
    }
    else if (dateFilter === 'all') {
      filters.date = 'all'
    }

    if (statusFilter !== 'All') {
      filters.status = statusFilter
    }

    return filters
  }

  const fetchSettings = async () => {
    try {
      const res = await BillService.getGeneralSettings()
      setSettings(res || {})
    } catch (err) {
      console.log("Settings Error:", err)
    }
  }

  const fetchData = async () => {
    if (!canView) return
    setLoading(true)
    try {

      const filters = buildFilters()

      const response = await BillService.getBillReport(filters)
      console.log(" RAW RESPONSE:", response)
      const rows = Array.isArray(response)
        ? response
        : Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response?.data?.data)
            ? response.data.data
            : []
      console.log(" PARSED ROWS:", rows)
      const rowsWithSettings = rows.map((r) => ({
        ...r,
        settings: r.settings || r.Settings || {} // safe fallback if backend still sends it
      }))
      setRowsRaw(rowsWithSettings)
    } catch (err) {
      console.error("❌ERROR:", err)
      notify.error(`Failed to load bill report: ${err.message}`)
      setRowsRaw([])
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    fetchData()
    fetchSettings()
  }, [])
  const handleClear = () => {
    if (!canUpdate && !canDelete) {
      notify.error('Permission Denied', 'No permission to clear sales report filters')
      return
    }
    setDateFilter('today')
    setRange(null)
    setStatusFilter('All')
    setSearchText('')
    setRowsRaw([])
  }
  // const rows = useMemo(() => {
  // const search = searchText.trim().toLowerCase()
  // return (rowsRaw || [])
  // .map((row) => {
  // const items = Array.isArray(row.items)
  // ? row.items
  // : Array.isArray(row.bill_items)
  // ? row.bill_items
  // : []
  // return {
  // ...row,
  // key: row.id,
  // discount: Number(row.discount || 0),
  // item_count: Number(row.item_count || items.length || 0),
  // items_total: Number(row.items_total || 0),
  // final_total: Number(row.final_total || 0),
  // items,
  // }
  // })
  // .filter((row) => {
  // if (!search) return true
  // const childMatch = (row.items || []).some((item) =>
  // [
  // item.item_name,
  // item.name,
  // item.food_name,
  // item.menu_name,
  // String(item.qty),
  // String(item.price),
  // ]
  // .join(' ')
  // .toLowerCase()
  // .includes(search)
  // )
  // return (
  // [
  // row.bill_no,
  // row.table_name,
  // row.zone,
  // row.status,
  // row.payment_method,
  // row.note,
  // String(row.item_count),
  // String(row.items_total),
  // String(row.final_total),
  // ]
  // .join(' ')
  // .toLowerCase()
  // .includes(search) || childMatch
  // )
  // })
  // }, [rowsRaw, searchText])
  const rows = useMemo(() => {
    const search = searchText.trim().toLowerCase()
    return (rowsRaw || [])
      .map((row) => {
        // ✅Parse payment_summary
        const payment_summary = (() => {
          const raw = row.payment_summary || row.bill_summary || {}
          if (!raw) return {}
          if (typeof raw === 'string') {
            try {
              return JSON.parse(raw)
            } catch {
              return {}
            }
          }
          return raw
        })()
        const items = Array.isArray(row.items)
          ? row.items
          : Array.isArray(row.bill_items)
            ? row.bill_items
            : []
        let items_total = 0
        let drinks_total = 0
        const updatedItems = items.map((item) => {
          let line_total = 0
          let displayDetails = []
          if (!item?.is_drink) {
            // FOOD
            line_total =
              Number(item?.qty || 0) * Number(item?.price || 0)
          } else {
            line_total = getDrinkLineTotal(item?.drink_details)
            drinks_total += line_total
          }
          items_total += line_total
          return {
            ...item,
            line_total,
            displayDetails,
          }
        })
        // =========================
        // FOOD TOTAL + TAX
        // =========================
        const food_total = updatedItems
          .filter((i) => !i.is_drink)
          .reduce((sum, i) => sum + Number(i.line_total || 0), 0)
        const food_cgst = Number(row.food_cgst || 0)
        const food_sgst = Number(row.food_sgst || 0)
        const items_total_final = food_total + food_cgst + food_sgst
        // =========================
        // DRINK TOTAL + TAX
        // =========================
        const drink_cgst = Number(row.drink_cgst || 0)
        const drink_sgst = Number(row.drink_sgst || 0)
        const drink_vat = Number(
          row.drink_vat ?? payment_summary.drink_vat ?? 0
        )
        const drinks_total_final =
          drinks_total + drink_cgst + drink_sgst + drink_vat
        const discount = Number(row.discount || 0)


        const hasParcel = items.some(
          item => Number(item.is_parcel || 0) === 1
        )

        const parcel_charge_total = getParcelCharge(items, settings)



        const additional_charge_total = Number(
          row.additional_charge_total ??
          row.additional_charge ??
          payment_summary.additional_charge_total ??
          payment_summary.additional_charge ??
          0
        )


        const ac_charge_total =
          row.zone?.trim().toLowerCase() === 'ac'
            ? Number(settings?.ac_charge || 0)
            : 0;




        console.log("Charge Debug:", {
          bill_id: row.id,
          parcel_charge_total,
          ac_charge_total,
          raw_row: row,
          payment_summary
        })


        const final_total =
          Number(items_total_final) +
          Number(drinks_total_final) +
          Number(ac_charge_total) +
          Number(parcel_charge_total)-
          discount
        return {
          ...row,
          key: row.id,
          items: updatedItems,
          item_count: Number(row.item_count || updatedItems.length),
          // FOOD base total (without tax)
          items_total: food_total,
          // DRINK base total (without tax)
          drinks_total: drinks_total,
          // tax-inclusive totals (kept separately)
          items_total_with_tax: items_total_final,
          drinks_total_with_tax: drinks_total_final,
          final_total,
          discount,
          // FOOD TAX
          food_cgst,
          food_sgst,
          food_discount: Number(row.food_discount || 0),
          food_total: Number(row.food_total || 0),
          // DRINK TAX
          drink_cgst,
          drink_sgst,
          drink_vat,
          drink_total: Number(row.drink_total || 0),
          parcel_charge_total,
          additional_charge_total,
          ac_charge_total,
        }
      })
      .filter((row) => {
        if (!search) return true
        const childMatch = (row.items || []).some((item) =>
          [
            item.item_name,
            String(item.qty),
            String(item.line_total),
          ]
            .join(' ')
            .toLowerCase()
            .includes(search)
        )
        return (
          [
            row.bill_no,
            row.table_name,
            row.zone,
            row.status,
            row.payment_method,
            String(row.items_total),
            String(row.drinks_total),
            String(row.final_total),
          ]
            .join(' ')
            .toLowerCase()
            .includes(search) || childMatch
        )
      })
  }, [rowsRaw, searchText, settings])
  const summary = useMemo(() => {
    const totalBills = rows.length
    const foodRevenue = rows.reduce(
      (sum, r) => sum + Number(r.items_total || 0),
      0
    )
    const drinkRevenue = rows.reduce(
      (sum, r) => sum + Number(r.drinks_total || 0),
      0
    )
    const totalTax = rows.reduce((sum, r) => {
      const foodTax =
        Number(r.food_cgst || 0) + Number(r.food_sgst || 0)
      const drinkTax =
        Number(r.drink_cgst || 0) +
        Number(r.drink_sgst || 0) +
        Number(r.drink_vat || 0)
      return sum + foodTax + drinkTax
    }, 0)
    const additionalCharges = rows.reduce(
      (sum, r) =>
        sum +
        Number(r.parcel_charge_total || 0) +
        Number(r.additional_charge_total || 0) +
        Number(r.ac_charge_total || 0),
      0
    )
    const totalAcCharge = rows.reduce(
      (sum, r) => sum + Number(r.ac_charge_total || 0),
      0
    )
    const totalParcelCharge = rows.reduce(
      (sum, r) => sum + Number(r.parcel_charge_total || 0),
      0
    )
    const totalRevenue = rows.reduce(
      (sum, r) => sum + Number(r.final_total || 0),
      0
    )
    const grandTotal = totalRevenue 
    const totalDiscount = rows.reduce(
      (sum, r) => sum + Math.abs(Number(r.discount || 0)),
      0
    )
    return {
      totalBills,
      foodRevenue,
      drinkRevenue,
      totalTax,
      additionalCharges,
      totalAcCharge,
      totalParcelCharge,
      totalRevenue,
      grandTotal,
      totalDiscount,
    }
  }, [rows])
  const reportRows = useMemo(() => {
    const out = []
    const foodMap = new Map()
    const drinkMap = new Map()
    let foodTotal = 0
    let drinkTotal = 0
    rows.forEach((row) => {
      const items = Array.isArray(row.items) ? row.items : []
      const rowFoodCgst = Number(row.food_cgst || 0)
      const rowFoodSgst = Number(row.food_sgst || 0)
      const rowFoodSubtotal = Number(row.items_total || 0) - rowFoodCgst - rowFoodSgst
      const rowDrinkCgst = Number(row.drink_cgst || 0)
      const rowDrinkSgst = Number(row.drink_sgst || 0)
      const rowDrinkVat = Number(row.drink_vat || 0)
      const rowDrinkSubtotal = Number(row.drinks_total || 0) - rowDrinkCgst - rowDrinkSgst -
        rowDrinkVat
      items.forEach((i) => {
        const name = (i.item_name || i.name || '-').toString().trim() || '-'
        const itemKey = name.toLowerCase()
        const qty = Number(i.qty || 0)
        const rate = Number(i.price || 0)
        const total = Number(i.line_total || qty * rate)
        if (Number(i.is_drink || 0) === 1) {
          let bottleQty = 0
          let pegQty = 0
          let bottleRate = 0
          let pegRate = 0
          let pegEntries = []
          try {
            const details = typeof i.drink_details === 'string' ? JSON.parse(i.drink_details || '{}') :
              (i.drink_details || {})
            bottleQty = Number(details.bottle_qty || 0)
            bottleRate = Number(details.price_bottle || 0)
            pegQty = Object.values(details.peg_qtys || {}).reduce((s, q) => s + Number(q || 0), 0)
            pegEntries = (details.pegs || [])
              .map((p) => {
                const q = Number((details.peg_qtys || {})[String(p.id)] || 0)
                if (q <= 0) return null
                return {
                  ml: `${Number(p.qty || 0)}ml`,
                  qty: q,
                  rate: Number(p.price || 0),
                }
              })
              .filter(Boolean)
            const pegPrices = (details.pegs || [])
              .filter((p) => Number((details.peg_qtys || {})[String(p.id)] || 0) > 0)
              .map((p) => Number(p.price || 0))
            pegRate = pegPrices.length ? Math.max(...pegPrices) : 0
          } catch { }
          const ratio = rowDrinkSubtotal > 0 ? total / rowDrinkSubtotal : 0
          const curr = drinkMap.get(itemKey) || {
            item_name: name, qty: 0, rate: 0, total: 0, bottleQty:
              0, pegQty: 0, bottleByRate: {}, pegRate: 0, pegByMlRate: {}, cgst: 0, sgst: 0, vat: 0
          }
          const nextBottleByRate = { ...(curr.bottleByRate || {}) }
          if (bottleQty > 0) {
            const key = String(Number(bottleRate || 0))
            nextBottleByRate[key] = {
              rate: Number(bottleRate || 0),
              qty:
                Number(nextBottleByRate[key]?.qty || 0) +
                Number(bottleQty || 0),
            }
          }
          const nextPegByMlRate = { ...(curr.pegByMlRate || {}) }
          pegEntries.forEach((entry) => {
            const key = `${entry.ml}|${Number(entry.rate || 0)}`
            const existing = nextPegByMlRate[key] || {
              ml: entry.ml, qty: 0, rate: Number(entry.rate || 0)
            }
            nextPegByMlRate[key] = {
              ml: entry.ml,
              qty: existing.qty + Number(entry.qty || 0),
              rate: Number(entry.rate || existing.rate || 0),
            }
          })
          drinkMap.set(itemKey, {
            item_name: curr.item_name || name,
            qty: curr.qty + qty,
            total: curr.total + total,
            bottleQty: curr.bottleQty + bottleQty,
            pegQty: curr.pegQty + pegQty,
            bottleByRate: nextBottleByRate, 
            pegByMlRate: nextPegByMlRate,
            cgst: curr.cgst + (rowDrinkCgst * ratio),
            sgst: curr.sgst + (rowDrinkSgst * ratio),
            vat: curr.vat + (rowDrinkVat * ratio),
          })
          drinkTotal += total
        } else {

          const itemCgst =
            (rowFoodCgst / rowFoodSubtotal) * total

          const itemSgst =
            (rowFoodSgst / rowFoodSubtotal) * total
          //const ratio = rowFoodSubtotal > 0 ? total / rowFoodSubtotal : 0
          const foodKey = name.toString().trim().toLowerCase()
          const curr = foodMap.get(foodKey) || {
            item_name: name,
            qty: 0,
            total: 0,
            cgst: 0,
            sgst: 0,
            qtyByRate: {},
            rate: rate,
          }
          const rateKey = Number(rate || 0).toFixed(2)
          const nextQtyByRate = { ...(curr.qtyByRate || {}) }
          nextQtyByRate[rateKey] = Number(nextQtyByRate[rateKey] || 0) + qty
          const nextRateSet = new Set(Object.keys(nextQtyByRate))
          const displayRate =
            nextRateSet.size === 1
              ? Number(rateKey)
              : Object.entries(nextQtyByRate)
                .map(([r, q]) => `₹${Number(r).toFixed(2)} x${q}`)
                .join('\n')
          foodMap.set(foodKey, {
            item_name: curr.item_name || name,
            qty: curr.qty + qty,
            total: curr.total + total,

            cgst: curr.cgst + itemCgst,
            sgst: curr.sgst + itemSgst,
            //cgst: curr.cgst + (rowFoodCgst * ratio),
            //sgst: curr.sgst + (rowFoodSgst * ratio),
            qtyByRate: nextQtyByRate,
            rate: displayRate,
          })
          foodTotal += total
        }
      })
    })
    out.push({ key: 'food-head', item_name: 'FOOD', isHeader: true })
    Array.from(foodMap.entries()).forEach(([name, v], idx) => {
      const qtyLines = v.qty
      const rateLines = v.qtyByRate && Object.keys(v.qtyByRate).length > 1
        ? Object.entries(v.qtyByRate).map(([rate, qty]) => `₹${Number(rate).toFixed(2)}
x${qty}`).join('\n')
        : (v.rate == null || v.rate === '' ? '' : Number(v.rate).toFixed(2))
      out.push({
        key: `food-${idx}`,
        item_name: v.item_name,
        qty: qtyLines,
        rate: rateLines,
        total: v.total.toFixed(2),
        cgst: Number(v.cgst || 0).toFixed(2),
        sgst: Number(v.sgst || 0).toFixed(2),
        tax: Number(
          Number(v.cgst || 0) + Number(v.sgst || 0)
        ).toFixed(2),
        grand_total: Number(
          Number(v.total || 0) +
          Number(v.cgst || 0) +
          Number(v.sgst || 0)
        ).toFixed(2),
      })
    })
    out.push({
      key: 'food-total',
      item_name: 'FOOD TOTAL',
      qty: Array.from(foodMap.values()).reduce((s, v) => s + v.qty, 0),
      rate: '',
      total: Number(foodTotal || 0).toFixed(2),
      cgst: rows.reduce((s, r) => s + Number(r.food_cgst || 0), 0).toFixed(2),
      sgst: rows.reduce((s, r) => s + Number(r.food_sgst || 0), 0).toFixed(2),
      tax: rows.reduce((s, r) => s + Number(r.food_cgst || 0) + Number(r.food_sgst || 0), 0).toFixed(2),
      grand_total: (
        Number(foodTotal || 0) +
        rows.reduce((s, r) => s + Number(r.food_cgst || 0), 0) +
        rows.reduce((s, r) => s + Number(r.food_sgst || 0), 0)
      ).toFixed(2),

    })
    out.push({ key: 'drink-head', item_name: 'DRINK', isHeader: true })
    Array.from(drinkMap.entries()).forEach(([name, v], idx) => {
      const pegAmount = Object.values(v.pegByMlRate || {}).reduce(
        (sum, d) => sum + Number(d.qty || 0) * Number(d.rate || 0),
        0
      )
      const bottleAmount = Object.values(v.bottleByRate || {}).reduce(
        (sum, d) => sum + Number(d.qty || 0) * Number(d.rate || 0),
        0
      )
      const drinkLineTotal = bottleAmount + pegAmount
      const grandDrink =
        drinkLineTotal +
        Number(v.cgst || 0) +
        Number(v.sgst || 0) +
        Number(v.vat || 0)
      const bottleLines = Object.values(v.bottleByRate || {}).map(
        (d) => `B:${d.qty} @ ${Number(d.rate).toFixed(2)}`
      )
      const pegLines = Object.values(v.pegByMlRate || {}).map(
        (d) => `${d.ml}: P:${d.qty} @ ${Number(d.rate).toFixed(2)}`
      )
      out.push({
        key: `drink-${idx}`,
        item_name: name,
        qty: [
          `B:${v.bottleQty || 0} P:${v.pegQty || 0}`,
          ...bottleLines,
          ...pegLines
        ].join('\n'),
        rate: [
          ...Object.values(v.bottleByRate || {}).map(
            (d) => `B:${Number(d.rate).toFixed(2)}`
          ),
          ...Object.values(v.pegByMlRate || {}).map(
            (d) => `${d.ml}: ${Number(d.rate).toFixed(2)}`
          )
        ].join('\n'),
        total: drinkLineTotal.toFixed(2),
        cgst: Number(v.cgst || 0).toFixed(2),
        sgst: Number(v.sgst || 0).toFixed(2),
        tax: Number(
          Number(v.cgst || 0) + Number(v.sgst || 0)
        ).toFixed(2),
        vat: Number(v.vat || 0).toFixed(2),
        grand_total: grandDrink.toFixed(2),
      })
    })
    out.push({
      key: 'drink-total',
      item_name: 'DRINK TOTAL',
      qty: Array.from(drinkMap.values()).reduce((s, v) => s + Number(v.bottleQty || 0) +
        Number(v.pegQty || 0), 0),
      rate: '',
      total: rows.reduce((s, r) => s + Number(r.drinks_total || 0), 0).toFixed(2),
      cgst: rows.reduce((s, r) => s + Number(r.drink_cgst || 0), 0).toFixed(2),
      sgst: rows.reduce((s, r) => s + Number(r.drink_sgst || 0), 0).toFixed(2),
      tax: rows.reduce((s, r) => s + Number(r.drink_cgst || 0) + Number(r.drink_sgst || 0),
        0).toFixed(2),
      vat: rows.reduce((s, r) => s + Number(r.drink_vat || 0), 0).toFixed(2),
      grand_total: (
        rows.reduce((s, r) => s + Number(r.drinks_total || 0), 0) +
        rows.reduce((s, r) => s + Number(r.drink_cgst || 0), 0) +
        rows.reduce((s, r) => s + Number(r.drink_sgst || 0), 0) +
        rows.reduce((s, r) => s + Number(r.drink_vat || 0), 0)
      ).toFixed(2),
    })

    return out
  }, [rows, summary])
  const foodRows = useMemo(
    () => reportRows.filter((r) => String(r.key).startsWith('food-')),
    [reportRows]
  )
  const drinkRows = useMemo(
    () =>
      reportRows.filter((r) =>
        ['drink-', 'tax', 'ac-charge', 'parcel-charge', 'charge', 'grand'].some((p) =>
          String(r.key).startsWith(p)
        )
      ),
    [reportRows]
  )
  const exportRows = useMemo(() => {
    const exportData = []
    rows.forEach((row) => {
      if (!row.items?.length) {
        exportData.push({
          'Bill No': row.bill_no || `BILL-${row.id}`,
          Table: row.table_name || '-',
          Zone: row.zone || '-',
          Status: row.status || '-',
          Payment: row.payment_method || '-',
          Items: row.item_count || 0,
          'Items Total': Number(row.items_total || 0).toFixed(2),
          Discount: Number(row.discount || 0).toFixed(2),
          'Final Total': Number(row.final_total || 0).toFixed(2),
          'Created At': row.created_at || '-',
          'Closed At': row.closed_at || '-',
          'Item Name': '',
          Qty: '',
          Price: '',
          'Line Total': '',
        })
      } else {
        row.items.forEach((item, index) => {
          exportData.push({
            'Bill No': index === 0 ? row.bill_no || `BILL-${row.id}` : '',
            Table: index === 0 ? row.table_name || '-' : '',
            Zone: index === 0 ? row.zone || '-' : '',
            Status: index === 0 ? row.status || '-' : '',
            Payment: index === 0 ? row.payment_method || '-' : '',
            Items: index === 0 ? row.item_count || 0 : '',
            'Items Total':
              index === 0 ? Number(row.items_total || 0).toFixed(2) : '',
            Discount: index === 0 ? Number(row.discount || 0).toFixed(2) : '',
            'Final Total':
              index === 0 ? Number(row.final_total || 0).toFixed(2) : '',
            'Created At': index === 0 ? row.created_at || '-' : '',
            'Closed At': index === 0 ? row.closed_at || '-' : '',
            'Item Name':
              item.item_name || item.name || item.food_name || item.menu_name || '-',
            Qty: Number(item.qty || 0),
            Price: Number(item.price || 0).toFixed(2),
            'Line Total': Number(
              item.line_total != null
                ? item.line_total
                : Number(item.qty || 0) * Number(item.price || 0)
            ).toFixed(2),
          })
        })
      }
    })
    return exportData
  }, [rows])

//hotel name and details fetching from db

const getHotelConfig = async () => {
  try {
    const res = await getPdfConfigAPI()

    console.log("PDF RESPONSE:", res)

    // The API returns the config directly, not inside a 'data' property
    // Based on your console output, res IS the config object
    const config = res || {}  // Changed from res?.data to res

    return {
      name: config.hotel_name || 'Hotel Name',     // ✓ matches API: hotel_name
      subtitle: config.subtitle || '',             // ✓ matches API: subtitle
      address: config.address || '', 
      phone: config.phone_no || '',              // ✓ matches API: address
      gst: config.gst_no || '',                    // ✓ matches API: gst_no
      vat: config.vat_no || '',                    // ✓ matches API: vat_no
      fssai: config.fssai_no || '',                // ✓ matches API: fssai_no
      footerTitle: config.footer_title || '',      // ✓ matches API: footer_title
      footerSubtitle: config.footer_subtitle || '',// ✓ matches API: footer_subtitle
      terms: config.terms || ''
    }

  } catch (err) {
    console.log("Error in getHotelConfig:", err)

    return {
      name: 'Hotel Name',
      subtitle: '',
      address: '',
      phone: '',  
      gst: '',
      vat: '',
      fssai: '',
      footerTitle: '',
      footerSubtitle: '',
      terms: ''
    }
  }
}







  const handleExportPdf = async () => {
    if (!rows.length) {
      notify.warning('No data to export')
      return
    }
   



    const hotel = await getHotelConfig()
  console.log("HOTEL DATA IN PDF:", hotel);

   

    // NEW = 4 inch width custom page
    const doc = new jsPDF({
      orientation: 'p',
      unit: 'mm',
      format: [80, 200 ] // height, width => 4 inch = 101.6 mm
    })

    



    const pageWidth = doc.internal.pageSize.getWidth()
    const pageHeight = doc.internal.pageSize.getHeight()
    let yPos = 12

    const leftPadding = 5

     const colItem = leftPadding
    const colQty = 40
    const colAmt = 60
    const colRate = 70
    const left = 1
    const padding = {
      left: 12,
      right: 12,
      top: 10,
      row: 5
    }



    // Header
    doc.setFontSize(10)
    doc.setTextColor(40)
    doc.setFont(undefined, 'bold')
    doc.text(hotel.name || 'Hotel Name', pageWidth / 2, yPos,{
      align: 'center'
    });
    yPos += 4


     doc.setFontSize(8)
    doc.text(hotel.subtitle, pageWidth / 2, yPos,{
      align: 'center'
    });
    yPos += 4 

    // Address - with text wrapping for 80mm width
      if (hotel.address) {
        doc.setFontSize(7)
        doc.setTextColor(60)
        
        // Split address into multiple lines to fit within page width (minus padding)
        const maxWidth = pageWidth - 10 // Leave 5mm padding on each side
        const addressLines = doc.splitTextToSize(hotel.address, maxWidth)
        
        addressLines.forEach((line) => {
          doc.text(line, pageWidth / 2, yPos, { align: 'center' })
          yPos += 4
        })
      }


  if (hotel.phone) {
  doc.setFontSize(7)
  doc.setTextColor(60)
  doc.text(`Phone: ${hotel.phone}`, pageWidth / 2, yPos, { align: 'center' });
  yPos += 4
}






    doc.setFontSize(8)
   doc.text('Sales Report', pageWidth / 2, yPos, {
      align: 'center'
    });
    yPos += 5
    // Date info
    doc.setFontSize(6)
    doc.setFont(undefined, 'normal')



    doc.setTextColor(60)
    const now = new Date()

    const dateStr = now.toLocaleDateString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).replace(/\//g, '-')

    const timeStr = now.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    })



    doc.text(`Date: ${dateStr}`,  pageWidth / 2, yPos, {
      align: 'center'
    });
    yPos += 4
    doc.text(`Print Time:  ${timeStr}`,  pageWidth / 2, yPos, {
      align: 'center'
    });
    yPos += 7
    // Headers for table
    doc.setFontSize(8)
    doc.setTextColor(40)
    doc.setFont(undefined, 'bold')
    doc.text('ITEM NAME', colItem, yPos)
    doc.text('QTY', colQty, yPos, { align: 'right' })
    doc.text('AMOUNT', colAmt, yPos, { align: 'right' })
    doc.text('RATE', colRate, yPos, { align: 'right' })
    yPos += 4
    doc.line(left, yPos, pageWidth - left, yPos)
    yPos += 4
    // Collect and group food and drink items by name and rate
    const foodMap = {}
    const drinkMap = {}
    rows.forEach((row) => {
      if (row.items && Array.isArray(row.items)) {
        row.items.forEach((item) => {
          const name = (item.item_name || item.name || '-').toString().trim() || '-'
          const itemKey = name.toLowerCase()
          const qty = Number(item.qty || 0)
          const isDrink = Number(item.is_drink || 0) === 1

          let rate = Number(item.price || 0)
          let amount = qty * rate
          let drinkRateEntries = []
          let parsedDrinkDetails = null

          // Handle drink details if available
          if (isDrink) {
            try {
              const details = typeof item.drink_details === 'string'
                ? JSON.parse(item.drink_details || '{}')
                : (item.drink_details || {})
              parsedDrinkDetails = details
              const bottleQty = Number(details.bottle_qty || 0)
              const bottleRate = Number(details.price_bottle || 0)
              if (bottleQty > 0) {
                drinkRateEntries.push({
                  qty: bottleQty,
                  rate: bottleRate,
                  amount: bottleQty * bottleRate,
                })
              }
              ; (details.pegs || []).forEach((p) => {
                const pegQty = Number((details.peg_qtys || {})[String(p.id)] || 0)
                if (pegQty <= 0) return
                const pegRate = Number(p.price || 0)
                drinkRateEntries.push({
                  qty: pegQty,
                  rate: pegRate,
                  amount: pegQty * pegRate,
                })
              })
              if (!drinkRateEntries.length) {
                drinkRateEntries.push({
                  qty,
                  rate: Number(item.price || 0),
                  amount: qty * Number(item.price || 0),
                })
              }
              const totalDrinkQty = drinkRateEntries.reduce((s, r) => s + Number(r.qty || 0), 0)
              const totalDrinkAmt = drinkRateEntries.reduce((s, r) => s + Number(r.amount || 0), 0)
              rate = totalDrinkQty > 0 ? Number(totalDrinkAmt / totalDrinkQty) : Number(item.price || 0)
              amount = totalDrinkAmt
            } catch (e) {
              // Fallback if parsing fails
              rate = Number(item.price || 0)
              amount = qty * rate
              drinkRateEntries = [{ qty, rate, amount }]
            }
          }
          if (isDrink) {
            if (!drinkMap[itemKey]) {
              drinkMap[itemKey] = { name, rates: {}, detailRows: {} }
            }
            drinkRateEntries.forEach((entry) => {
              const rateKey = Number(entry.rate || 0).toString()
              if (!drinkMap[itemKey].rates[rateKey]) {
                drinkMap[itemKey].rates[rateKey] = {
                  qty: 0,
                  totalAmount: 0,
                  rate: Number(entry.rate || 0),
                }
              }
              drinkMap[itemKey].rates[rateKey].qty += Number(entry.qty || 0)
              drinkMap[itemKey].rates[rateKey].totalAmount += Number(entry.amount || 0)
            })
            // Restore drink detail rows (Bottle / ml) under drink name
            try {
              const details = parsedDrinkDetails || (
                typeof item.drink_details === 'string'
                  ? JSON.parse(item.drink_details || '{}')
                  : (item.drink_details || {})
              )
              const bottleQty = Number(details.bottle_qty || 0)
              const bottleRate = Number(details.price_bottle || 0)
              if (bottleQty > 0) {
                const detailKey = `bottle|${bottleRate}`
                if (!drinkMap[itemKey].detailRows[detailKey]) {
                  drinkMap[itemKey].detailRows[detailKey] = {
                    label: 'Bottle',
                    qty: 0,
                    rate: bottleRate,
                    amount: 0,
                  }
                }
                drinkMap[itemKey].detailRows[detailKey].qty += bottleQty
                drinkMap[itemKey].detailRows[detailKey].amount += bottleQty * bottleRate
              }
              ; (details.pegs || []).forEach((p) => {
                const pegQty = Number((details.peg_qtys || {})[String(p.id)] || 0)
                if (pegQty <= 0) return
                const pegRate = Number(p.price || 0)
                const pegLabel = `${Number(p.qty || 0)}ml`
                const detailKey = `peg|${pegLabel}|${pegRate}`
                if (!drinkMap[itemKey].detailRows[detailKey]) {
                  drinkMap[itemKey].detailRows[detailKey] = {
                    label: pegLabel,
                    qty: 0,
                    rate: pegRate,
                    amount: 0,
                  }
                }
                drinkMap[itemKey].detailRows[detailKey].qty += pegQty
                drinkMap[itemKey].detailRows[detailKey].amount += pegQty * pegRate
              })
            } catch {
              // ignore detail parse error
            }
          } else {
            if (!foodMap[itemKey]) {
              foodMap[itemKey] = { name, rates: {} }
            }
            const rateKey = rate.toString()
            if (!foodMap[itemKey].rates[rateKey]) {
              foodMap[itemKey].rates[rateKey] = { qty: 0, totalAmount: 0, rate }
            }
            foodMap[itemKey].rates[rateKey].qty += qty
            foodMap[itemKey].rates[rateKey].totalAmount += amount
          }
        })
      }
    })
    doc.setFont(undefined, 'normal')
    doc.setFontSize(8)
    // Food section
    const foodItems = Object.values(foodMap)
    if (foodItems.length > 0) {
      let foodQtyTotal = 0
      let foodAmountTotal = 0
      foodItems.forEach((item) => {
        Object.values(item.rates).forEach((rateData) => {
          foodQtyTotal += rateData.qty
          foodAmountTotal += rateData.totalAmount
        })
      })
      doc.setFont(undefined, 'bold')
      doc.text('DEPT: FOOD', colItem, yPos)
      doc.text(String(foodQtyTotal), colQty, yPos, { align: 'right' })
      doc.text(String(foodAmountTotal.toFixed(0)), colAmt, yPos, { align: 'right' })
      yPos += 5
      doc.setFont(undefined, 'normal')
      foodItems.forEach((item) => {
        const rateList = Object.values(item.rates)
        rateList.forEach((rateData, idx) => {
          const itemName = idx === 0 ? item.name.substring(0, 15) : ''
          doc.text(itemName, colItem, yPos)
          doc.text(String(rateData.qty), colQty, yPos, { align: 'right' })
          doc.text(String(rateData.totalAmount.toFixed(0)), colAmt, yPos, { align: 'right' })
          doc.text(String(rateData.rate.toFixed(0)), colRate, yPos, { align: 'right' })
          yPos += 5
          if (yPos > pageHeight - 15) {
            doc.addPage()
            yPos = 12
          }
        })
      })
      yPos += 3
    }
    // Drink section
    const drinkItems = Object.values(drinkMap)
    if (drinkItems.length > 0) {
      let drinkQtyTotal = 0
      let drinkAmountTotal = 0
      drinkItems.forEach((item) => {
        Object.values(item.rates).forEach((rateData) => {
          drinkQtyTotal += rateData.qty
          drinkAmountTotal += rateData.totalAmount
        })
      })
     doc.setFont(undefined, 'bold')

        // Department title
        doc.text('DEPT: BAR', colItem, yPos)

        // Totals aligned properly
        doc.text(String(drinkQtyTotal), colQty, yPos, { align: 'right' })
        doc.text(String(drinkAmountTotal.toFixed(0)), colAmt, yPos, { align: 'right' })

        yPos += 4
        doc.setFont(undefined, 'normal')
      drinkItems.forEach((item) => {
        const details = Object.values(item.detailRows || {})
        const bottleRows = details
          .filter((d) => String(d.label || '').toLowerCase() === 'bottle')
          .sort((a, b) => Number(a.rate || 0) - Number(b.rate || 0))
        const pegRows = details
          .filter((d) => String(d.label || '').toLowerCase() !== 'bottle')
          .sort((a, b) => {
            const aml = Number(String(a.label || '').replace(/[^0-9.]/g, '') || 0)
            const bml = Number(String(b.label || '').replace(/[^0-9.]/g, '') || 0)
            if (aml !== bml) return aml - bml
            return Number(a.rate || 0) - Number(b.rate || 0)
          })
        const printDrinkLine = (nameText, row) => {
          doc.text((nameText || '').substring(0, 15), colItem, yPos)
          doc.text(String(Number(row.qty || 0)), colQty, yPos, { align: 'right' })
          doc.text(String(Number(row.amount || 0).toFixed(0)), colAmt, yPos, { align: 'right' })
          doc.text(String(Number(row.rate || 0).toFixed(0)), colRate, yPos, { align: 'right' })
          yPos += 5
          if (yPos > pageHeight - 15) {
            doc.addPage()
            yPos = 12
          }
        }


        if (bottleRows.length || pegRows.length) {
          bottleRows.forEach((row, idx) => {
            // First bottle line prints drink name, next bottle lines keep name blank
            printDrinkLine(idx === 0 ? item.name : '', row)
          })

          pegRows.forEach((row, idx) => {
            // First row for each peg ml shows "60ml(DrinkName)", same ml next lines are blank-name
            const prev = pegRows[idx - 1]
            const isFirstOfMl = !prev || String(prev.label) !== String(row.label)
            const pegName = isFirstOfMl ? `${row.label}(${item.name})` : ''
            printDrinkLine(pegName, row)
          })

        } else {
          // Fallback when detail rows are unavailable
          const rateList = Object.values(item.rates)

          rateList.forEach((rateData, idx) => {
            const itemName = idx === 0 ? item.name.substring(0, 15) : ''

            doc.text(itemName, colItem, yPos)
            doc.text(String(rateData.qty), colQty, yPos, { align: 'right' })
            doc.text(String(rateData.totalAmount.toFixed(0)), colAmt, yPos, { align: 'right' })
            doc.text(String(rateData.rate.toFixed(0)), colRate, yPos, { align: 'right' })

            yPos += 3

            if (yPos > pageHeight - 15) {
              doc.addPage()
              yPos = 12
            }
          })
        }


      })
      yPos += 3
    }
    // Grand total
    doc.setFont(undefined, 'bold')
    doc.setFontSize(8)
    let totalQty = 0
    foodItems.forEach((item) => {
      Object.values(item.rates).forEach((rateData) => {
        totalQty += rateData.qty
      })
    })
    drinkItems.forEach((item) => {
      Object.values(item.rates).forEach((rateData) => {
        totalQty += rateData.qty
      })
    })
    const grandTotal =
      rows.reduce((sum, r) =>
        sum + Number(r.items_total || 0) + Number(r.drinks_total || 0),
        0
      )
    doc.text('GRANDTOTAL:', colItem, yPos)
    doc.text(String(totalQty), colQty, yPos, { align: 'right' })
    doc.text(String(grandTotal.toFixed(0)), colAmt, yPos, { align: 'right' })
    yPos += 5
    // Footer
    doc.setFontSize(7)
    doc.setFont(undefined, 'normal')
    doc.setTextColor(120)
    doc.text('***** End Of Report *****', pageWidth / 2, yPos, { align: 'center' })
    openPdfPrintDialog(doc)
  }









  //report 2
  const handleExportPdf2 = async () => {
    if (!rows.length) {
      notify.warning('No data to export')
      return
    }
    console.log("ROWS DATA:", rows)





  const hotel = await getHotelConfig()

    




    // NEW = 4 inch width custom page
    const doc = new jsPDF({
      orientation: 'p',
      unit: 'mm',
      format: [80,200] // 4 inch width
    })

    doc.setFontSize(7)   
    doc.setTextColor(40)


   const pageWidth = doc.internal.pageSize.getWidth()
    const left = 3
    const right = 3
    let y = 12

    // ===============================
    // HEADER ADDED HERE
    // ===============================
    doc.setFontSize(10)
    doc.setTextColor(40)
    doc.setFont(undefined, 'bold')
    doc.text(hotel.name, pageWidth / 2, y,{
      align: 'center'
    });

    y += 5

    doc.setFontSize(8)
    doc.text(hotel.subtitle, pageWidth / 2, y,{
      align: 'center'
    });
    y+=4

    // Address - with text wrapping for 80mm width
    if (hotel.address) {
      doc.setFontSize(7)
      doc.setTextColor(60)
      
      // Split address into multiple lines to fit within page width (minus padding)
      const maxWidth = pageWidth - 10 // Leave 5mm padding on each side
      const addressLines = doc.splitTextToSize(hotel.address, maxWidth)
      
      addressLines.forEach((line) => {
        doc.text(line, pageWidth / 2, y, { align: 'center' })
        y += 4
      })
    }


  if (hotel.phone) {
  doc.setFontSize(7)
  doc.setTextColor(60)
  doc.text(`Phone: ${hotel.phone}`, pageWidth / 2, y, { align: 'center' });
  y += 4
}










    doc.setFontSize(8)
    doc.text('Sales Summary', pageWidth / 2, y,{
      align: 'center'
    });

    y += 7


    const addLine = (label, value = '', indent = 0, bold = false) => {
      doc.setFont(undefined, bold ? 'bold' : 'normal')
      doc.setFontSize(bold ? 7 : 6)

      doc.text(String(label), left + indent, y)

      if (value !== '') {
        doc.text(String(value), pageWidth - right, y, { align: 'right' })
      }

      y += 4 // reduced spacing (fix overlap)
    }
        const addSection = (title) => {
      y += 2
      doc.setFont(undefined, 'bold')
      doc.setFontSize(7)

      doc.text(title, left, y)

      y += 4
    }

    const toAmount = (n) => Number(n || 0).toFixed(2)
    const toInt = (n) => Number(n || 0)

    const totalCgst = rows.reduce(
      (sum, r) => sum + Number(r.food_cgst || 0) + Number(r.drink_cgst || 0),
      0
    )
    const totalSgst = rows.reduce(
      (sum, r) => sum + Number(r.food_sgst || 0) + Number(r.drink_sgst || 0),
      0
    )
    const totalVat = rows.reduce((sum, r) => sum + Number(r.drink_vat || 0), 0)


    //-----additional charge
    const acCharge = rows.reduce(
      (sum, r) => sum + Number(r.ac_charge_total || 0),
      0
    )

    const parcelCharge = rows.reduce(
      (sum, r) => sum + Number(r.parcel_charge_total || 0),
      0
    )

    const additionalCharge = acCharge + parcelCharge

    const grossSale = Number(summary.grandTotal || 0) + Number(summary.totalDiscount || 0)
    const netSale = Number(summary.grandTotal || 0)
    const taxesAndCess = Number(totalCgst || 0) + Number(totalSgst || 0) + Number(totalVat || 0)
    const netExclTax = netSale - taxesAndCess

    const settledRows = rows.filter((r) => String(r.status || '').toLowerCase() === 'closed')
    const unsettledBills = rows.length - settledRows.length

    const cashTotal = settledRows
      .filter((r) => String(r.payment_method || '').toLowerCase() === 'cash')
      .reduce((sum, r) => sum + Number(r.final_total || 0), 0)

    const digitalTotal = settledRows
      .filter((r) => String(r.payment_method || '').toLowerCase() !== 'cash')
      .reduce((sum, r) => sum + Number(r.final_total || 0), 0)

    const payOut = rows.reduce(
      (sum, r) =>
        sum +
        Number(
          r?.payment_summary?.pay_out ??
          r?.payment_summary?.payout ??
          0
        ),
      0
    )
    const payIn = rows.reduce(
      (sum, r) =>
        sum +
        Number(
          r?.payment_summary?.pay_in ??
          r?.payment_summary?.payin ??
          0
        ),
      0
    )

    // -----------------------------
    // TOTAL ITEMS (Food + Drink)
    // -----------------------------
    const totalItems = rows.reduce(
      (sum, r) =>
        sum +
        (Array.isArray(r.items)
          ? r.items.reduce(
            (s, item) => s + Number(item.qty || 0),
            0
          )
          : 0),
      0
    )





    const firstBillNo = rows.length ? (rows[rows.length - 1]?.bill_no || '-') : '-'
    const lastBillNo = rows.length ? (rows[0]?.bill_no || '-') : '-'

    const printDateTime = dayjs().format('DD/MM/YYYY hh:mm A')
    const reportDateText =
      dateFilter === 'custom' && range?.length === 2
        ? `${dayjs(range[0]).format('DD/MM/YYYY hh:mm A')} - ${dayjs(range[1]).format('DD/MM/YYYY hh:mm A')}`
        : dayjs().format('ddd DD MMM YYYY')

    doc.setFontSize(8)
    addLine(`Date ${reportDateText}`, '', 0, true)
    addLine(`Print Date ${printDateTime}`)

    addSection('Sales Summary')
    addSection('Sales Details (Rs)')
    addLine('Sales', Math.round(netSale))
    addLine('Taxes & Cess', toAmount(taxesAndCess))
    addLine('Gross Sale', Math.round(grossSale), 0, true)
    addLine('Discount', toAmount(summary.totalDiscount))
    addLine('Net Sale', Math.round(netSale), 0, true)
    addLine('Net Excl. Tax', toAmount(netExclTax))

    addSection('Tax Breakup (Rs)')
    addLine(`CGST`, toAmount(totalCgst))
    addLine(`SGST`, toAmount(totalSgst))
    addLine(`VAT`, toAmount(totalVat))

    addSection('Cashier Details (Rs)')
    addLine('Cash', Math.round(cashTotal))
    addLine('Digital', Math.round(digitalTotal))
    addLine('Unsettled Bills', String(toInt(unsettledBills)))
    addLine('Pay Out', toAmount(payOut))
    addLine('Pay In', toAmount(payIn))
    addLine('Cash in Drawer', Math.round(cashTotal + payIn - payOut))



    addSection('Department')
    addLine('Food', toAmount(summary.foodRevenue))
    //addLine('Bar', toAmount(summary.drinkRevenue))



    addSection('Additional Charge')
    addLine('AC Charge', toAmount(acCharge))
    addLine('Parcel Charge', toAmount(parcelCharge))
    addLine('Total Charge', toAmount(additionalCharge), 0, true)



    addSection('Other Values')
    addLine('Items Added', String(totalItems))

    addLine('First Bill No', firstBillNo)
    addLine('Last Bill No', lastBillNo)
    addLine('No of Bills', String(toInt(summary.totalBills)))
    addLine('Print Date', printDateTime)


    // GST and FSSAI (if available) - at the bottom
  let taxLine = ''
  if (hotel.gst && hotel.fssai) {
    taxLine = `GST: ${hotel.gst}  |  FSSAI: ${hotel.fssai}`
  } else if (hotel.gst) {
    taxLine = `GST: ${hotel.gst}`
  } else if (hotel.fssai) {
    taxLine = `FSSAI: ${hotel.fssai}`
  }
  
  if (taxLine) {
    doc.setFontSize(6)
    doc.setFont(undefined, 'normal')
    doc.setTextColor(80)
    doc.text(taxLine, pageWidth / 2, y, { align: 'center' });
    y += 4
  }
  
  // VAT if available
  if (hotel.vat) {
    doc.setFontSize(6)
    doc.setFont(undefined, 'normal')
    doc.setTextColor(80)
    doc.text(`VAT: ${hotel.vat}`, pageWidth / 2, y, { align: 'center' });
    y += 4
  }

    doc.text('***** End Of Report *****', pageWidth / 2, y, { align: 'center' })
    
    
    openPdfPrintDialog(doc)
  }










  const childColumns = [
    {
      title: 'Item',
      dataIndex: 'item_name',
      key: 'item_name',
      render: (_, record) => (
        <div className="bill-item-cell">
          <span className="bill-item-dot" />
          <div>
            <div className="bill-item-name">
              {record.item_name || record.name || '-'}
            </div>
            {/* show drink details */}
            {record.is_drink && record.displayDetails?.length > 0 && (
              <div className="bill-item-sub">
                {record.displayDetails.map((d, i) => (
                  <div key={i}>• {d}</div>
                ))}
              </div>
            )}
          </div>
        </div>
      ),
    },
    {
      title: 'Qty',
      dataIndex: 'qty',
      key: 'qty',
      align: 'center',
      // render: (value) => Number(value || 0),
      render: (_, record) => {
        if (!record.is_drink) return Number(record.qty || 0)
        try {
          const details = JSON.parse(record.drink_details || '{}')
          const bottleQty = Number(details.bottle_qty || 0)
          const pegQty =
            details.peg_qtys
              ? Object.values(details.peg_qtys).reduce(
                (sum, q) => sum + Number(q || 0),
                0
              )
              : 0
          return `B:${bottleQty} / P:${pegQty}`
        } catch {
          return '-'
        }
      }
    },
    {
      title: 'Price',
      key: 'price',
      align: 'right',
      render: (_, record) => {
        if (record.is_drink) {
          // show computed drink total
          return `₹${Number(record.line_total || 0).toFixed(2)}`
        }
        // normal food price
        return `₹${Number(record.price || 0).toFixed(2)}`
      },
    },
    {
      title: 'Line Total',
      key: 'line_total',
      align: 'right',
      render: (_, record) => {
        // const total =
        // record.line_total != null
        // ? Number(record.line_total)
        // : Number(record.qty || 0) * Number(record.price || 0)
        const total =
          record.line_total != null
            ? Number(record.line_total)
            : Number(record.qty || 0) * Number(record.price || 0)
        return <strong>₹{total.toFixed(2)}</strong>
      },
    },
  ]
  const mainColumns = [
    {
      title: 'Item Name', dataIndex: 'item_name', key: 'item_name', width: 260, render: (v, r) =>
        r.isHeader ? <strong>{v}</strong> : v
    },
    { title: 'QTY', dataIndex: 'qty', key: 'qty', width: 180, render: (v) => <span style={{ whiteSpace: 'preline' }}>{v}</span> },
    {
      title: 'RATE', dataIndex: 'rate', key: 'rate', align: 'right', render: (v) => <span style={{
        whiteSpace:
          'pre-line'
      }}>{(v == null || v === '' ? '' : typeof v === 'string' ? v : `₹${Number(v).toFixed(2)}`)}</span>
    },
    {
      title: 'TOTAL', dataIndex: 'total', key: 'total', align: 'right', render: (v) => (v == null || v === '' ? '' :
        `${v}`)
    },
    { title: 'CGST', dataIndex: 'cgst', key: 'cgst' },
    { title: 'SGST', dataIndex: 'sgst', key: 'sgst' },
    { title: 'TAX', dataIndex: 'tax', key: 'tax' },
    { title: 'VAT', dataIndex: 'vat', key: 'vat' },
    {
      title: 'GRAND TOTAL', dataIndex: 'grand_total', key: 'grand_total', align: 'right', render: (v) => (v
        == null || v === '' ? '' : `₹${Number(v).toFixed(2)}`)
    },
  ]
  const foodColumns = mainColumns.filter((c) => c.key !== 'vat')
  return (
    !canView ? (
      <Card>
        <Empty description="No permission to view sales report" />
      </Card>
    ) : (
    <div className="bill-report-page">
      <div className="bill-report-hero">
        <div className="bill-report-hero-left">
          <div className="bill-report-hero-icon">
            <FileDoneOutlined />
          </div>
          <div>
            <h2 className="bill-report-hero-title">Sales Report</h2>
            <p className="bill-report-hero-subtitle">
              Modern hotel-style sales analytics with detailed item-wise sales report.
            </p>
          </div>
        </div>





        <div className="bill-report-hero-actions">
          <Button
            icon={<FilePdfOutlined />}
            onClick={handleExportPdf}
            className="bill-report-export-btn pdf"
            disabled={!rows.length || !canCreate}
          >
            Sales Report
          </Button>

          <Button
            icon={<FilePdfOutlined />}
            onClick={handleExportPdf2}
            className="bill-report-export-btn pdf"
            disabled={!rows.length || !canCreate}
          >
            Sales Summary
          </Button>



        </div>






      </div>
      <Card className="bill-report-card">
        <Row gutter={[12, 12]} className="bill-report-filters">
          <Col xs={24} sm={12} md={8} lg={5}>
            <Select
              value={dateFilter}
              onChange={setDateFilter}
              disabled={isViewOnly}
              options={[
                { label: 'Today', value: 'today' },
                { label: 'Yesterday', value: 'yesterday' },
                { label: 'All', value: 'all' },
                { label: 'Custom Range', value: 'custom' },
              ]}
            />
          </Col>



          {dateFilter === 'custom' && !isViewOnly && (
            <Col xs={24} sm={24} md={12} lg={8}>
              <RangePicker
                showTime={{
                  format: 'hh:mm:ss A',
                  use12Hours: true,
                }}
                format="DD-MM-YYYY hh:mm:ss A"
                style={{ width: '100%' }}
                value={range}
                onChange={(vals) => setRange(vals)}
                placeholder={['Start Date Time', 'End Date Time']}
              />
            </Col>
          )}





          <Col xs={24} sm={12} md={8} lg={5}>
            <Select
              value={statusFilter}
              onChange={setStatusFilter}
              disabled={isViewOnly}
              options={[
                { label: 'All Status', value: 'All' },
                { label: 'Open', value: 'open' },
                { label: 'Closed', value: 'closed' },
              ]}
            />
          </Col>
          <Col xs={24} sm={12} md={6} lg={3}>
            <Button
              type="primary"
              block
              icon={<ReloadOutlined />}
              className="bill-report-load-btn"
              onClick={fetchData}
              loading={loading}
              disabled={!canView}
            >
              Load
            </Button>
          </Col>
          <Col xs={24} sm={12} md={6} lg={4}>
            <Button
              block
              className="bill-report-clear-btn"
              onClick={handleClear}
              disabled={!canUpdate && !canDelete}
            >
              Clear
            </Button>
          </Col>
        </Row>
        <div className="bill-report-toolbar">
          <Input
            allowClear
            placeholder="Search bills or child items..."
            prefix={<SearchOutlined />}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="bill-report-search"
          />
        </div>
        <Row gutter={[16, 16]} className="bill-report-stats">
          <Col xs={24} sm={12} md={8} lg={4}>
            <Card className="bill-report-stat-card">
              <Statistic
                title="Total Bills"
                value={summary.totalBills}
                prefix={<FileDoneOutlined />}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} md={8} lg={4}>
            <Card className="bill-report-stat-card">
              <Statistic
                title="Total Discount"
                value={summary.totalDiscount}
                precision={2}
                formatter={(v) => `₹${Number(v || 0).toFixed(2)}`}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} md={8} lg={4}>
            <Card className="bill-report-stat-card">
              <Statistic
                title="Food Revenue"
                value={summary.foodRevenue}
                precision={2}
                formatter={(v) => `₹${Number(v || 0).toFixed(2)}`}
              />
            </Card>
          </Col>
         {/* <Col xs={24} sm={12} md={8} lg={4}>
            <Card className="bill-report-stat-card">
              <Statistic
                title="Drink Revenue"
                value={summary.drinkRevenue}
                precision={2}
                formatter={(v) => `₹${Number(v || 0).toFixed(2)}`}
              />
            </Card>
          </Col>   */}
          <Col xs={24} sm={12} md={8} lg={4}>
            <Card className="bill-report-stat-card">
              <Statistic
                title="Total Tax Collected"
                value={summary.totalTax}
                precision={2}
                prefix={
                  <Tooltip title="All GST tax added">
                    <InfoCircleOutlined
                      style={{
                        fontSize: 22,
                        color: '#6454ee',
                        cursor: 'pointer',
                      }}
                    />
                  </Tooltip>
                }
                formatter={(value) => `₹${Number(value || 0).toFixed(2)}`}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} md={8} lg={4}>
            <Card className="bill-report-stat-card">
              <Statistic
                title="Additional Charges"
                value={summary.additionalCharges}
                precision={2}
                formatter={(v) => `₹${Number(v || 0).toFixed(2)}`}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} md={8} lg={4}>
            <Card className="bill-report-stat-card">
              <Statistic
                title="Total Revenue"
                //value={summary.totalRevenue}
                value={summary.grandTotal}
                precision={2}
                prefix={<DollarOutlined />}
                formatter={(v) => `₹${Math.round(Number(v || 0)).toLocaleString('en-IN')}`}
              />
            </Card>
          </Col>
        </Row>

        <Divider/>

        <Spin spinning={loading}>
          {!rows.length ? (
            <div className="bill-report-empty">
              <Empty description="No bill report data found" />
            </div>
          ) : (
            <div >
              <h3 style={{ marginBottom: 10 }}>Food Table</h3>
              <Table
                rowKey="key"
                columns={foodColumns}
                dataSource={foodRows}
                pagination={{ pageSize: 10 }}
              />
             {/* <h3 style={{ margin: '18px 0 10px' }}>Drink Table</h3>
              <Table
                rowKey="key"
                columns={mainColumns}
                dataSource={drinkRows}
                pagination={{ pageSize: 10 }}
              />    */}
              
              <Divider/>

              <h3 style={{ marginBottom: 10, textAlign: 'left' }}>
                Calculation
              </h3>
              {/* FOOD TOTAL */}
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Food Total</span>
                <span>
                  ₹{summary.foodRevenue.toFixed(2)}
                </span>
              </div>
              {/* DRINK TOTAL */}
            {/*  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Drink Total</span>
                <span>
                  ₹{summary.drinkRevenue.toFixed(2)}
                </span>
              </div>  */}
              {/* AC CHARGE */}
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>AC Charge</span>
                <span>₹{summary.totalAcCharge.toFixed(2)}</span>
              </div>
              {/* PARCEL CHARGE */}
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Parcel Charge</span>
                <span>₹{summary.totalParcelCharge.toFixed(2)}</span>
              </div>
              {/* DISCOUNT */}
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Total Discount</span>
                <span style={{ color: 'red' }}>
                  -₹{summary.totalDiscount.toFixed(2)}
                </span>
              </div>
              {/* TAX */}
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Total Tax</span>
                <span>
                  ₹{summary.totalTax.toFixed(2)}
                </span>
              </div>
              <hr style={{ margin: '8px 0' }} />
              {/* GRAND TOTAL */}
              <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700 }}>
                <span>Grand Total</span>
                <span>
                  ₹{Math.round(summary.grandTotal)}
                </span>
              </div>
            </div>
          )}
        </Spin>
      </Card>
    </div>
    )
  )
}
export default SalesReport
